const GLOBAL_TYPES = {
  RESET_STORE: '[global] resetStore'
}

export default GLOBAL_TYPES
